module.exports = __webpack_public_path__ + "img/2.bb22a488.png";